module.exports = "<div class=warning-container><ul><li class=warning-item ng-repeat=\"warning in $ctrl.model\"><span ng-bind=::warning></span></li></ul><div class=panel-btn><button class=\"btn btn-kt\" ng-click=$ctrl.continue()><l10n>CONTINUE</l10n></button> <button class=\"btn btn-dark\" ng-click=$ctrl.cancel()><l10n>EDIT</l10n></button></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/validation-warning/validation-warning.html
// module id = 863
// module chunks = 0